export default __webpack_public_path__ + "static/media/Letter V.1727f419.mov";